import { render, staticRenderFns } from "./ViewPhoto.vue?vue&type=template&id=3135ab9a&scoped=true&"
import script from "./ViewPhoto.vue?vue&type=script&lang=js&"
export * from "./ViewPhoto.vue?vue&type=script&lang=js&"
import style0 from "./ViewPhoto.vue?vue&type=style&index=0&id=3135ab9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3135ab9a",
  null
  
)

export default component.exports